/**
 * Persisted "last-used build view" preference (specs/challenge-flow-redesign — T-53).
 * The Build screen opens on whichever view (deck / list) the user last had open, across app
 * restarts — no settings UI; the toggle itself IS the preference. New users default to 'deck'.
 */

import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import { platformStorage } from '../../shared/stores/platformStorage';
import type { BuildView } from '../types/create.types';

interface BuildViewPrefState {
  preferredBuildView: BuildView;
  setPreferredBuildView: (view: BuildView) => void;
}

export const useBuildViewPrefStore = create<BuildViewPrefState>()(
  persist(
    (set) => ({
      preferredBuildView: 'deck',
      setPreferredBuildView: (view: BuildView) => set({ preferredBuildView: view }),
    }),
    {
      name: 'zporti_build_view_pref',
      storage: createJSONStorage(() => platformStorage),
      partialize: (state) => ({ preferredBuildView: state.preferredBuildView }),
    }
  )
);
